import { NETWORK_LOG } from "../../../constants/envConstant";
import { CRITICAL_ACTION_TIMEOUT } from "../../../constants/values";
import { apiEndPoint } from "../../../env";
import { AuthUtil } from "../../../views/auth/AuthUtil";

const ReportInterface = {
  getReportList: async function (id) {
    let requestUrl = apiEndPoint + "/ecohive/reports";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };

    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let res = await fetch(requestUrl + "?projectId=" + id, requestOptions)
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    return res;
  },

  getReportDetails: async function (id, reportId) {
    let requestUrl = apiEndPoint + "/ecohive/reports";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let res = await fetch(
      requestUrl + "?projectId=" + id + "&id=" + reportId,
      requestOptions
    )
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });
    return res;
  },

  deleteReport: async (pId, tId) => {
    let requestUrl = apiEndPoint + "/ecohive/report";
    const controller = new AbortController();
    let token = await AuthUtil.getAuthToken();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: token },
      signal: controller.signal,
      credentials: "include",
      cache: "no-cache",
    };
    const timeoutId = setTimeout(
      () => controller.abort(),
      CRITICAL_ACTION_TIMEOUT
    );
    let res = await fetch(
      requestUrl + "?projectId=" + pId + "&id=" + tId,
      requestOptions
    )
      .then((res) => {
        return res.text().then((text) => {
          const data = text && JSON.parse(text);
          return data;
        });
      })
      .catch((err) => {
        if (err.name === "AbortError") {
          return "fetch() request was aborted, hit CTRL-R to try again.";
        }
        console.log(err);
      });

    return res;
  },

  log: function (msg, flag) {
    if (NETWORK_LOG || flag) console.log(`[ReportInterface] ${msg}`);
  },
};

export default ReportInterface;
